import React, { Component } from "react";
import { FilePond, File, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import path from "path";
import { withNamespaces } from "react-i18next";
import { Button } from "reactstrap";
import FormModel from "./models/form";
import Fade from "react-reveal/Fade";
import { Autocomplete, TextField } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import { Services } from "../../../../../../repositories/clients/Services";
import RepositoryFactory from "../../../../../../repositories/RepositoryFactory";
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
// const rest = new RestService()
const filesAccepted = [
  "image/jpg",
  "image/png",
  "image/jpeg",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "text/xml",
];

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000a2e",
  },
  euroDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
});

const DocumentsRepository = RepositoryFactory.get("Documents");
const maxSizeFile = 10000000;

class Tracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Form: FormModel,
      files: [],
      Document: {},
      id: 0,
      selects: {
        "DOC-CATEGORIES": [],
      },
      Inputs: "",
      disable: false,
    };
  }

  componentDidMount = () => {
    this.getCategoriescatalog();
    this.setState(
      {
        id: this.props.id,
      },
      () => {
        this.buildForm();
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        id: nextProps.id,
      },
      () => {
        this.buildForm();
      }
    );
  };

  getCategoriescatalog = async () => {
    let categories = await DocumentsRepository.getCategories(3, this.props.lng);
    if (categories) {
      const response = categories.data;
      console.log("response", response);
      const selectOptions = { "DOC-CATEGORIES": response };

      this.setState({ selects: selectOptions }, () => this.buildForm());
    }
  };

  handleChange = (name) => (event) => {
    let { Document } = this.state;
    Document[name] = event.target.value;
    this.setState({ Document }, () => {
      this.buildForm();
    });
  };

  handleChangeSelect = (selected) => (event, data) => {
    let { Document, Form } = this.state;

    if (data && data.value) {
      Document[selected] = data.value;
      this.setState({ Document, Form }, () => {
        this.buildForm();
      });
    } else {
      Document[selected] = "";
      this.setState({ Document, Form }, () => {
        this.buildForm();
      });
    }
  };

  handleChangeDate = (name) => (event) => {
    let { Document } = this.state;
    try {
      Document[name] = event.format("YYYY-MM-DD");
      this.setState({ Document }, () => {
        this.buildForm();
      });
    } catch (ex) {
      Document[name] = "";
      this.setState({ Document });
    }
  };

  buildForm = () => {
    const { Document, selects, Form } = this.state;

    const { classes } = this.props;
    let Inputs = Form.map((e, i) => {
      if (e.type === "Input" && e.show)
        return (
          <div className={e.class} key={e.id}>
            <Fade left opposite>
              {" "}
              <span id={this.props.t(e.label)} style={e.style}>
                <label>
                  {this.props.t(e.label)}{" "}
                  {e.required === true ? <span>*</span> : ""}
                </label>
              </span>
            </Fade>

            <TextField
              // label={e.placeHolder}
              style={{ marginTop: "-2px" }}
              id={e.id}
              title={this.props.t("fill_field")}
              variant="standard"
              placeholder={this.props.t(e.placeHolder)}
              type={e.datatype}
              name={e.id}
              value={Document[e.id]}
              maxlength={e.maxlength}
              minlength={e.minlength}
              InputProps={{
                classes: {
                  input: "input-euro",
                },
              }}
              onChange={this.handleChange(e.id)}
              max={e.max}
            />
            <Fade left opposite>
              <label style={e.style}>{e.error}</label>
            </Fade>
          </div>
        );
      else if (e.type === "Select" && e.show)
        return (
          <div className={e.class} key={e.id}>
            <Fade left opposite>
              <span id={this.props.t(e.label)} style={e.style}>
                {" "}
                <label>
                  {this.props.t(e.label)}{" "}
                  {e.required === true ? <span>*</span> : ""}{" "}
                </label>
              </span>
            </Fade>
            <Autocomplete
              closeText={false}
              openText={false}
              // style={{ marginTop: "6px" }}
              id="size-small-standard"
              className="input-euro"
              size="small"
              // freeSolo
              ListboxProps={{
                sx: { fontSize: 12 },
              }}
              sx={{
                "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                  fontSize: 12,
                },
              }}
              options={selects[e.options] ? selects[e.options] : []}
              getOptionLabel={(option) => option.text}
              onChange={this.handleChangeSelect(e.id)}
              value={Document[e.id]}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  className={classes.textfield}
                />
              )}
            />

            <Fade left opposite>
              <label style={e.style}>{e.error}</label>
            </Fade>
          </div>
        );
      else return "";
    });
    this.setState({
      Inputs,
    });
  };
  CreateNewComment = (evt) => {
    evt.preventDefault();

    let { Document, id } = this.state;
    const formData = new FormData();
    if (Document.file && Document.Name && Document.CategoryId) {
      formData.append("file", Document.file);
      formData.append("Name", Document.Name);
      formData.append("DocCategoryId", parseInt(Document.CategoryId));
      formData.append("Type", path.extname(Document.file.name));
      formData.append("RowId", id);
      formData.append("ModuleId", 3);
      formData.append("UserId", this.props._user);
      let url = `${Services.TRACEABILITY.path}trazabilidad/upload-documents/`;
      this.setState({ disable: true });
      fetch(`${url}`, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((success) => {
          this.props.callback(success);
        })
        .catch((error) => {
          this.props.onError(error);
        });
    }
  };

  onDrop = (fileItems) => {
    let { Document } = this.state;
    Document.file = fileItems.length > 0 ? fileItems[0].file : "";
    this.setState({ Document }, () => this.buildForm());
  };
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12 pt-2">
            <FilePond
              labelIdle={this.props.t("select_or_drag_files")}
              acceptedFileTypes={filesAccepted}
              labelInvalidField={this.props.t("invalid_file_format")}
              labelFileTypeNotAllowed={this.props.t("invalid_file_format")}
              fileValidateTypeLabelExpectedTypes={this.props.t(
                "only_images_doc_pdf_xml"
              )}
              allowMultiple={false}
              allowFileSizeValidation={true}
              maxFileSize={"10MB"}
              labelMaxFileSizeExceeded={this.props.t("file_size_not_available")}
              labelMaxFileSize={this.props.t("file_size_not_available")}
              fileValidateTypeDetectType={(source, type) => {
                this.setState({ disable: filesAccepted.indexOf(type) < 0 });
                console.log("type", type);
                return new Promise((resolve, reject) => {
                  // Do custom type detection here and return with promise
                  if (filesAccepted.indexOf(type) >= 0) {
                    resolve(type);
                  } else {
                    reject(type);
                  }
                });
              }}
              onupdatefiles={(fileItems) => {
                this.setState({ disable: true });
                if (
                  fileItems.length > 0 &&
                  fileItems[0].file.size <= maxSizeFile
                ) {
                  this.setState({ disable: false });
                }
                this.setState(
                  {
                    files: fileItems.map((fileItem) => fileItem.file),
                  },
                  () => {
                    this.onDrop(fileItems);
                  }
                );
              }}
            >
              {this.state.files.map((file) => (
                <File key={file} src={file} origin="local" />
              ))}
            </FilePond>
          </div>
        </div>
        <div className="row" style={{ marginTop: "5vh" }}>
          {this.state.Inputs}
        </div>
          <div className="btns-modal-container pt-3">
            <Button
              color="secondary"
              className="custom-width-btn mr-2"
              onClick={this.props.onCancel}
            >
              {this.props.t("po_management_detail_reject_alert_button_cancel")}
            </Button>
            <Button
              disabled={this.state.disable}
              color="primary"
              onClick={this.CreateNewComment}
              className="custom-width-btn"
            >
              {this.props.t("save")}
            </Button>
          </div>
      </>
    );
  }
}

export default withNamespaces()(withStyles(useStyles)(Tracking));
